import React, { useContext } from 'react';
import LineItemRecur from '../models/LineItemRecur'
import { RecursContext } from './Recurs'
import { EnvContext } from './Env'

const LineItemsExtensionContext = React.createContext();

const LineItemsExtensionProvider = (props) => {
  const [recurs] = useContext(RecursContext)
  const env = useContext(EnvContext)

  let lineItems = (props && props.value || []).map((lineItemProps) => LineItemRecur(lineItemProps, recurs.find((recur) => recur.matches(lineItemProps.order_id))))
  // shopper#827 : sort extensions by processed_at desc
  lineItems = lineItems.sort(function(a, b){ return new Date(b.processed_at) - new Date(a.processed_at)})

  props.onLineItems && props.onLineItems(lineItems)

  return (
    <LineItemsExtensionContext.Provider value={lineItems}>
      {props.children}
    </LineItemsExtensionContext.Provider>
  );
};

export { LineItemsExtensionContext, LineItemsExtensionProvider}
